<template>
  <div class="devicePermission-container section-main__warp">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%; width: 100%">
      <div class="section-mian_right">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="permissionOption"
            :page="page"
            @row-save="handleCreate"
            @row-update="handleUpdate"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @selection-change="handleSelectionChange"
            @current-change="selectPage"
            @size-change="changeSize"
          >
            <!-- 表格列 自定义 -->
            <template slot="menuLeft">
              <el-button
                type="primary"
                v-auth="'/authGroup/index:add'"
                size="small"
                class="iss-operation-button"
                icon="el-icon-plus"
                @click="handleGroup"
              >
                新增
              </el-button>
              <el-button
                v-auth="'/authGroup/index:delete'"
                type="primary"
                size="small"
                class="iss-operation-button"
                icon="el-icon-delete"
                @click="batchDelete"
              >
                批量删除
              </el-button>
            </template>
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="修改"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  v-auth="'/authGroup/index:update'"
                  icon="iconfont icon-xiugai"
                  @click="handleEdit(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  v-auth="'/authGroup/index:delete'"
                  icon="iconfont icon-shanchu"
                  @click="handleDel(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="权限配置"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-zhanghushezhi"
                  @click="handleConfig(scope.row)"
                ></el-button>
              </el-tooltip>
              <!-- <el-tooltip class="item"
                          effect="dark"
                          content="详情"
                          placement="top"
                          popper-class="tooltip-draw">
                <el-button type="text"
                           icon="iconfont icon-Detail"
                           @click="handleView(scope.row, scope.index)"></el-button>
              </el-tooltip> -->
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { api } from "../api";
import { Dic, Bus, Dates } from "$utils";
import utils from "$utils";
import i18n from "@src/common/lib/i18n";
import { permissionOption } from "../const/crud/permissionOptions";
export default {
  components: {},
  filters: {
    statusFilter(val) {
      return Dic.findByValue("SENU080001", val);
    },
  },
  data() {
    return {
      permissionOption: permissionOption(),
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      // 列表查询参数
      searchParams: {},
      checkedAuthGroups: [],
    };
  },
  created() {},
  mounted() {
    this.getList();
  },
  methods: {
    // 获取设备权限组列表
    getList() {
      const params = {};
      params.authGroupName = this.searchParams.authGroupName;
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.group.queryAuthGroupList, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },
    // 新增权限组
    handleGroup() {
      this.$refs.accessTab.rowAdd();
    },
    handleCreate(addInfo, done) {
      this.$refs["accessTab"].$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let params = {
            authGroupName: addInfo.authGroupName,
            desc: addInfo.desc,
          };
          this.$fetch(api.group.addAuthGroup, params).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
              return;
            } else {
              this.$message.success(
                response.msgContent || "新增设备权限组成功"
              );
              this.getList();
            }
            done();
          });
        }
      });
    },
    // 修改
    handleEdit(row, index) {
      this.$refs.accessTab.rowEdit(row, index);
    },
    handleUpdate(updateInfo, done) {
      this.$refs["accessTab"].$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        } else {
          let params = {
            authGroupCode: updateInfo.authGroupCode,
            authGroupName: updateInfo.authGroupName,
            desc: updateInfo.desc,
          };
          this.$fetch(api.group.updateAuthGroup, params).then((response) => {
            if (!response.success) {
              this.$message.error(response.msgContent);
              return;
            } else {
              this.$message.success(
                response.msgContent || "修改设备权限组成功"
              );
              this.getList();
            }
            done();
          });
        }
      });
    },
    handleSelectionChange(items) {
      this.checkedAuthGroups = items.map((item) => {
        return item.authGroupCode;
      });
    },
    // 删除
    handleDel(row) {
      const params = {
        authGroupCodeList: [row.authGroupCode],
      };
      this.$confirm("您确定删除该设备权限组吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.group.deleteAuthGroup, params).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getList();
        });
      });
    },
    // 批量删除
    batchDelete() {
      if (this.checkedAuthGroups.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要删除的设备权限组",
        });
        return;
      }
      const params = {
        authGroupCodeList: this.checkedAuthGroups,
      };
      this.$confirm("您确定删除这些设备权限组吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$fetch(api.group.deleteAuthGroup, params).then((response) => {
            if (!response.success) {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
              return;
            }
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
            this.getList();
          });
        })
        .catch(function (error) {});
    },

    // 权限组权限配置
    handleConfig(row) {
      this.$router.push({
        path: "/authGroup/operate",
        name: "operate",
        query: {
          type: "1",
          code: row.authGroupCode,
        },
      });
    },
    // 查看详情
    handleView(row) {
      this.$router.push({
        path: "/authGroup/operate",
        name: "operate",
        query: {
          type: "2",
          code: row.authGroupCode,
        },
      });
    },
    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      this.searchParams = Object.assign(param);
      this.page.currentPage = 1;
      this.getList();
    },
    // 重置按钮
    resetQuery() {
      this.getList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      this.getList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.devicePermission-container {
  .el-table__fixed-right-patch {
    display: none;
  }
  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}
</style>
